import React, { useRef, useEffect, useState, Suspense, useContext, useMemo } from 'react';
import { Menu, Layout, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { selectAuth } from '@/redux/auth/selectors';
import history from '@/utils/history';
import { useLocation } from 'react-router-dom'; // Import useLocation

// Lazy load components
const ToMeetingDashboard = React.lazy(() => import('./ToMeetingDashboard'));
const MyApproval = React.lazy(() => import('./MyApproval'));
const MyInitiatives = React.lazy(() => import('./MyInitiativesAndMilestones'));
const MyDashboard = React.lazy(() => import('./MyDashboard'));
const DataIssuesTable = React.lazy(() => import('./DataHyeign'));
const CTODashboard = React.lazy(() => import('./CTODashboard'));
const WorkstreamStatistics = React.lazy(() => import('./WorkstreamStatistics'));
const KPIOverview = React.lazy(() => import('./KPIOverview'));
const PendingApprovalsTable = React.lazy(() => import('./PendingApprovalsTable'));
const PendingWeeklyStatusApprovalsTable = React.lazy(() => import('./PendingWeeklyStatusApprovalsTable'));
import { useFilterActions } from './Clicks/handleClick';
const EXECUTIVE_ASSISTANT_ALLOWED_SOURCES = ['CMC', 'EMC', 'AMC', 'Office of CEO'];
// import { AppContext } from '@/app';
const { Header, Content } = Layout;
const Dashboard = ({
  subworkstream,
  users,
  allInitiative,
  actionItem,
  setAttributeFilters,
  attributeFilters,
  setActiveFilterType,
  filterHistory,
  setFilterHistory,
  initiativeColors,
  setSelectedMenu,
  setAggregatedAttributes,
  colorByAttribute,
  selectedGroup,
  setSelecetdInfoMenu,
  setColorByAttribute,
  setSelectedImpactGroup,
  setSelectedGroup,
  workstream,
  setSortField,
  setSortOrder,
  setYAxis,
  setSelectedDateRange,
  milestones
}) => {
  const {
    handleCardClick,
    handleStageBasedClick,
    handleTOPipelineOverviewClick,
    handleClickAgenda,
    handleL1PlusClick,
    handleL2PlusClick,
    handleL3PlusClick,
    handleSelectedInitiatives,
    handlePendingApprovalClick,
    handleNetRecurringBenefitStackedClick,
    workstreamActionClick,
    handlePending,
    handleOneTimeBenefitStackedClick,
    handleOnetimeImplementationCostClick,
    handleOneTimeImplementationCostStackedClick,
    LWClick,
    currentClick,
    changeClick,
    handleFilterMyInitiatives,
    handleActionItemClick,
    handleTypeRowClick,
    handleKpiRowClick,
    handleMonthlyTypeClick,
    handleMonthlyKpiGroupClick,
    handleMissingKPIActualClick,
    handleDuesoonFilterMyInitiatives,
    handleDuesoon30FilterMyInitiatives,
  } = useFilterActions(
    setAttributeFilters,
    setActiveFilterType,
    setFilterHistory,
    setSelectedMenu,
    setSelectedDateRange,
    history,
    setAggregatedAttributes,
    colorByAttribute,
    selectedGroup,
    setSelecetdInfoMenu,
    setColorByAttribute,
    setSelectedImpactGroup,
    setSelectedGroup,
    workstream,
    setSortField,
    setSortOrder,
    subworkstream,
    setYAxis,

  )
  const workbookRef = useRef(null);
  const otherElementRef = useRef(null);
  const currentUser = useSelector(selectAuth);
  const location = useLocation();
  const isExecutiveAssistant = currentUser?.role?.name === 'Executive Assistant';
  // const { refreshInitiatives } = useContext(AppContext);
  const allowedRolesForMyApproval = [
    'Workstream Lead',
    'Workstream Sponsor',
    'TO Finance',
    'Strategy Analyst',
    'CTO',
    'Admin'
  ];
  const canViewStatusRequest = [
    'Workstream Sponsor',
    'CTO',
    'Admin'
  ];
  const canViewMilestoneRequest = [
    'Workstream Lead',
    'Workstream Sponsor',
    'CTO',
    'Admin'
  ];
  const isCTORole = currentUser.role.name === 'CTO';
  const isAdmin = currentUser.role.name === 'Admin';
  const allowedCTO = isCTORole || isAdmin;
  const fullAccessRoles = ['CTO', 'Admin', 'Strategy Analyst', 'TO Finance'];
  const myWorkstreamActionData = useMemo(() => {
    if (!actionItem || !currentUser) return [];

    return actionItem.filter((action) => {
      // If user is Executive Assistant
      if (isExecutiveAssistant) {
        // Check if user is the owner - handle both object and string ID
        let isOwner = false;
        if (action?.owner) {
          if (typeof action.owner === 'object' && action.owner._id) {
            isOwner = action.owner._id.toString() === currentUser.id.toString();
          } else if (typeof action.owner === 'string') {
            isOwner = action.owner.toString() === currentUser.id.toString();
          } else if (typeof action.owner === 'object' && action.owner.id) {
            isOwner = action.owner.id.toString() === currentUser.id.toString();
          }
        }

        // Check if user is a collaborator - handle both object and string ID
        const isCollaborator = action?.collaborator?.some((colla) => {
          if (!colla) return false;
          let collabId = null;
          if (typeof colla === 'object' && colla._id) {
            collabId = colla._id;
          } else if (typeof colla === 'object' && colla.id) {
            collabId = colla.id;
          } else if (typeof colla === 'string') {
            collabId = colla;
          }
          return collabId && collabId.toString() === currentUser.id.toString();
        });

        // Check if source is allowed
        const hasAllowedSource = EXECUTIVE_ASSISTANT_ALLOWED_SOURCES.includes(action?.source);

        // Include if user is owner, collaborator, OR has allowed source
        return isOwner || isCollaborator || hasAllowedSource;
      }

      // For other users, use the existing logic
      const ownerWorkstream =
        action?.owner?.workstream?._id === currentUser?.workstream?._id ||
        action?.owner?.subworkstream?.workstream?._id === currentUser?.subworkstream?.workstream?._id;
      const ownerSubworkstream =
        action?.subworkstream?._id === currentUser?.subworkstream?._id;

      const collaboratorWorkstreams = action?.collaborator?.some(
        (colla) =>
          colla?.workstream?._id === currentUser?.workstream?._id ||
          colla?.subworkstream?.workstream?._id === currentUser?.subworkstream?.workstream?._id
      );

      const collaboratorSubworkstreams = action?.collaborator?.some(
        (colla) =>
          colla?.subworkstream?._id === currentUser?.subworkstream?._id
      );

      const haveFullAccess = fullAccessRoles.includes(currentUser?.role?.name);

      return (
        ownerWorkstream ||
        ownerSubworkstream ||
        collaboratorWorkstreams ||
        collaboratorSubworkstreams ||
        haveFullAccess
      );
    });
  }, [actionItem, currentUser, isExecutiveAssistant]);
  // State to hold the selected view, initialized from the URL or localStorage
  const [selectedView, setSelectedView] = useState(() => {
    const params = new URLSearchParams(location.search);
    const menuFromUrl = params.get('menu');
    return menuFromUrl || localStorage.getItem('selectedDashboardView') || 'My-Dashboard';
  });

  // Effect to update localStorage whenever selectedView changes
  useEffect(() => {
    localStorage.setItem('selectedDashboardView', selectedView);
  }, [selectedView]);

  // Effect to read the view from the URL on page load or URL change
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const menuFromUrl = params.get('menu');
    if (menuFromUrl) {
      setSelectedView(menuFromUrl);
    }
  }, [location.search]);

  // Effect to handle the initial workbook section
  useEffect(() => {
    if (window.location.search === '?section=workbook' && workbookRef.current) {
      workbookRef.current.scrollTop = 0;
    }
  }, []);

  const handleMenuClick = (e) => {
    const newView = e.key;
    setSelectedView(newView);
    // Update the URL to reflect the new view
    history.push(`?section=dashboard&menu=${newView}`);
  };

  const filteredAction = myWorkstreamActionData.filter((action) => action.status === 'Not Completed');
  const initiatives = React.useMemo(() => {
    if (!allInitiative || !Array.isArray(allInitiative) || !currentUser) {
      return [];
    }
    return allInitiative.filter((item) => {
      if (currentUser?.hasSpecialAccess === true) {
        return true;
      }
      const isOwner = item.initiativeOwnerInfo?.[0]?._id === currentUser.id;
      const isBackupOwner = item.initiativeOwnerBackupInfo?.[0]?._id === currentUser.id;
      const isWorkstreamLead = item.workstreamLeadInfo?.[0]?._id === currentUser.id;
      const isWorkstreamSponsor = item.workstreamSponsorInfo?.[0]?._id === currentUser.id;
      const isAllowedUser = item.AllowOnlyTo?.some(
        (allowedUser) => allowedUser._id === currentUser.id
      );
      const isMilestoneOwner = item.milestones?.some(
        (milestone) => milestone.Owner === currentUser.id
      );
      const isAdminRole =
        currentUser.role.name === 'CTO' ||
        currentUser.role.name === 'TO Finance' ||
        currentUser.role.name === 'Strategy Analyst' ||
        currentUser.role.name === 'Admin';
      const hasAccess =
        isOwner ||
        isBackupOwner ||
        isWorkstreamLead ||
        isWorkstreamSponsor ||
        isAllowedUser ||
        isMilestoneOwner ||
        isAdminRole;
      return hasAccess;
    });
  }, [allInitiative, currentUser]);


  const menuItems = useMemo(() => {
    const items = [
      { key: 'My-Dashboard', label: 'My Dashboard' },
      { key: 'My-Initiative', label: 'My Initiative and My Milestones' },
    ];

    // Pending Approval - only for allowed roles
    if (allowedRolesForMyApproval.includes(currentUser?.role?.name)) {
      items.push({ key: 'My-Approval', label: 'Pending Approval' });
    }

    // To Meeting Dashboard - label changes for Executive Assistant
    items.push({
      key: 'To-Meeting',
      label: isExecutiveAssistant ? 'Office of the CEO' : 'To Meeting Dashboard'
    });

    // SteerCo Workstream Update
    items.push({ key: 'SteerCo-Workstream-update', label: 'SteerCo Workstream Update' });

    // CTO Dashboard - only for CTO, Admin, or special access
    if (allowedCTO) {
      items.push({ key: 'CTO-Dashboard', label: 'CTO Dashboard' });
    }

    // KPI Overview
    items.push({ key: 'kpi-overview', label: 'KPI OverView' });

    // Other menu items
    items.push(
      { key: 'Hyiegn', label: 'Hyiegn' },
      { key: 'Sequencial', label: 'Sequencial' },
      { key: 'Other', label: 'Other' }
    );

    return items;
  }, [currentUser, isExecutiveAssistant, allowedCTO]);
  const renderView = () => {
    switch (selectedView) {
      case 'My-Dashboard':
        return <MyDashboard
          initiatives={initiatives}
          attributeFilters={attributeFilters}
          setAttributeFilters={setAttributeFilters}
          setActiveFilterType={setActiveFilterType}
          filterHistory={filterHistory}
          setFilterHistory={setFilterHistory}
          setSelectedMenu={setSelectedMenu}
          setAggregatedAttributes={setAggregatedAttributes}
          colorByAttribute={colorByAttribute}
          selectedGroup={selectedGroup}
          setSelecetdInfoMenu={setSelecetdInfoMenu}
          setColorByAttribute={setColorByAttribute}
          setSelectedImpactGroup={setSelectedImpactGroup}
          setSelectedGroup={setSelectedGroup}
          workstream={workstream}
          setSortField={setSortField}
          setSortOrder={setSortOrder}
          setYAxis={setYAxis}
          setSelectedDateRange={setSelectedDateRange}
        />;
      case 'kpi-overview':
        return (
          <Suspense fallback={
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <Spin size="large" tip="Loading KPI Overview..." />
            </div>
          }>
            <KPIOverview
              initiatives={initiatives}
              handleTypeRowClick={handleTypeRowClick}
              handleKpiRowClick={handleKpiRowClick}
              handleMonthlyTypeClick={handleMonthlyTypeClick}
              handleMonthlyKpiGroupClick={handleMonthlyKpiGroupClick}
              handleMissingKPIActualClick={handleMissingKPIActualClick}
            />
          </Suspense>
        );
      case 'My-Initiative':
        return (
          <MyInitiatives
            initiatives={initiatives}
            currentUser={currentUser}
            actionItem={myWorkstreamActionData}
            setAttributeFilters={setAttributeFilters}
            setActiveFilterType={setActiveFilterType}
            setFilterHistory={setFilterHistory}
            setSelectedMenu={setSelectedMenu}
            setAggregatedAttributes={setAggregatedAttributes}
            colorByAttribute={colorByAttribute}
            selectedGroup={selectedGroup}
            setSelecetdInfoMenu={setSelecetdInfoMenu}
            setColorByAttribute={setColorByAttribute}
            setSelectedImpactGroup={setSelectedImpactGroup}
            setSelectedGroup={setSelectedGroup}
            workstream={workstream}
            setSortField={setSortField}
            setSortOrder={setSortOrder}
            setYAxis={setYAxis}
            setSelectedDateRange={setSelectedDateRange}
            users={users}
            handleFilterMyInitiatives={handleFilterMyInitiatives}
            handleDuesoonFilterMyInitiatives={handleDuesoonFilterMyInitiatives}
            handleDuesoon30FilterMyInitiatives={handleDuesoon30FilterMyInitiatives}
            handleActionItemClick={handleActionItemClick}
            allMyInitiativeMilestones={milestones}
          />
        );
      case 'SteerCo-Workstream-update':
        return (
          <WorkstreamStatistics
            initiatives={initiatives}
            handleCardClick={handleCardClick}
            handleStageBasedClick={handleStageBasedClick}
            currentUser={currentUser}

          />
        )
      case 'To-Meeting':
        return (
          <ToMeetingDashboard
            actionItem={filteredAction}
            otherElementRef={otherElementRef}
            initiative={initiatives}
            subworkstream={subworkstream}
            workstream={workstream}
            users={users}
            setAttributeFilters={setAttributeFilters}
            setFilterHistory={setFilterHistory}
            setSelectedMenu={setSelectedMenu}
            setSelecetdInfoMenu={setSelecetdInfoMenu}
            handleNetClick={handleTOPipelineOverviewClick}
            onAgendaClick={handleClickAgenda}
            handleL1Click={handleL1PlusClick}
            handleL2Click={handleL2PlusClick}
            handleL3Click={handleL3PlusClick}
            handleClick={handleSelectedInitiatives}
            handleApprovalClick={handlePendingApprovalClick}
            handleWorkstreamActionClick={workstreamActionClick}
            handlePending={handlePending}
            LWClick={LWClick}
            currentClick={currentClick}
            changeClick={changeClick}
          />
        );
      case 'CTO-Dashboard':
        return <CTODashboard
          initiatives={initiatives}
          setAttributeFilters={setAttributeFilters}
          setActiveFilterType={setActiveFilterType}
          setFilterHistory={setFilterHistory}
          initiativeColors={initiativeColors}
          setSelectedMenu={setSelectedMenu}
          setAggregatedAttributes={setAggregatedAttributes}
          colorByAttribute={colorByAttribute}
          selectedGroup={selectedGroup}
          setSelecetdInfoMenu={setSelecetdInfoMenu}
          setColorByAttribute={setColorByAttribute}
          setSelectedImpactGroup={setSelectedImpactGroup}
          setSelectedGroup={setSelectedGroup}
          workstream={workstream}
          setSortField={setSortField}
          setSortOrder={setSortOrder}
          setYAxis={setYAxis}
          handleNetRecurringBenefitClick={handleNetRecurringBenefitStackedClick}
          handleOneTimeBenefit={handleOneTimeBenefitStackedClick}
          handleOneTimeCost={handleOnetimeImplementationCostClick}
          handleOneTimeImplementationCost={handleOneTimeImplementationCostStackedClick}
          setSelectedDateRange={setSelectedDateRange}
        />;
      case 'Hyiegn':
        return <DataIssuesTable initiatives={initiatives} subworkstream={subworkstream} />;
      case 'My-Approval':
        // refreshInitiatives();
        return (
          <>
            <MyApproval
              initiatives={initiatives}
              otherElementRef={otherElementRef}
              users={users}
              currentUser={currentUser}
            />
            {canViewMilestoneRequest.includes(currentUser.role.name) && (
              <PendingApprovalsTable initiatives={initiatives} users={users} />
            )}
            {canViewStatusRequest.includes(currentUser.role.name) && (
              <PendingWeeklyStatusApprovalsTable initiatives={initiatives} users={users} />
            )}
          </>
        );
      case 'Sequencial':
        return <div></div>;
      case 'Other':
        return <div></div>;
      default:
        return null;
    }
  };

  return (
    <Layout>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginLeft: '200px',
        }}
      >
        <Menu
          onClick={handleMenuClick}
          selectedKeys={[selectedView]}
          mode="horizontal"
          style={{ flex: 1 }}
        >
          {menuItems.map((item) => (
            <Menu.Item key={item.key}>{item.label}</Menu.Item>
          ))}
        </Menu>
      </Header>
      <Layout>
        <Content style={{ padding: '24px', minHeight: '280px', marginLeft: '200px' }}>
          <Suspense fallback={<div style={{ textAlign: 'center', padding: '50px' }}><Spin size="large" tip="Loading dashboard..." /></div>}>
            {renderView()}
          </Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};
export default Dashboard;